export enum EventType {
  View = 1,
  Print = 2,
  Download = 3,
  Transmit = 4,
}
